import React, { useState, Suspense } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { RootReducerState } from 'reduxStore/rootReducers';
import { FormattedMessage } from 'react-intl';
import { englishToNepaliNumber } from 'nepali-number';
import { loadable } from 'react-lazily/loadable';
const BranchAtmFilter = React.lazy(() => import('pages/branches/BranchAtmFilter'));
const Card = React.lazy(() => import('./Card'));
const { NetworkStatus } = loadable(() => import('components'), {
	fallback: <>Loading...</>,
});
interface Props {
	tabKey: string;
	setSelectedATMData: (atm: any) => void;
	setActiveTab: (tab: string) => void;
}

const ATMListView = ({ tabKey, setSelectedATMData, setActiveTab }: Props) => {
	const [searchText, setSearchText] = useState('');

	const { atmList, loading, error } = useSelector(({ atmListReducer }: RootReducerState) => ({
		error: atmListReducer.error,
		loading: atmListReducer.loading,
		atmList: atmListReducer.data,
	}));

	const filterData =
		atmList?.length > 0
			? atmList.filter((list) => {
					if (searchText) {
						return String(list.atm_name).toLowerCase().includes(searchText) || String(list.address).toLowerCase().includes(searchText);
					} else {
						return true;
					}
			  })
			: [];
	const { locale } = useSelector(
		({ intl }: RootReducerState) => ({
			locale: intl.currentLocale,
		}),
		shallowEqual
	);
	return (
		<div className="tab-content">
			<BranchAtmFilter filterType="atm" handleSearch={(text) => setSearchText(text)} tabKey={tabKey} setActiveTab={setActiveTab} />
			{filterData.length > 0 && (
				<div className=" pb-2 border-danger  d-flex justify-content-end align-items-center">
					<h5
						className="bg-danger text-white px-2 py-1  mb-0"
						style={{
							borderRadius: '20px',
							fontSize: '12px',
						}}
					>
						<FormattedMessage id="global.total" />: {locale == 'ne' ? englishToNepaliNumber(filterData.length) : filterData.length}
					</h5>
				</div>
			)}

			<NetworkStatus loading={loading} error={error} hasData={atmList.length} />
			<div className="row">
				{filterData?.length > 0 &&
					filterData.map((atm, index) => (
						<div key={index} className="col-lg-4 col-md-3 col-sm-6 my-2">
							<Suspense fallback={<div>Loading...</div>}>
								<Card setActiveTab={setActiveTab} setSelectedATMData={setSelectedATMData} atm={atm} />
							</Suspense>
						</div>
					))}
			</div>
		</div>
	);
};

export default ATMListView;
